// Stores
import { useUiStore } from '@stores/ui';

// Personal lib
import { UpdateServiceNameEnum } from './common/update-service-enum';
import { UpdateService } from './common/update-service.class';
import adminRepository from 'src/data/repository/admin.repository';
import { RepositoryStrategyEnum } from '@shared/enum/repository-strategy.enum';

export class UpdateManagerUser {
  /**
   * UpdateService : get all users
   */
  static UserAll = class UpdateServiceUserAll extends UpdateService {
    updateServiceName = UpdateServiceNameEnum.USER_ALL;

    /**
     * Cron store of cron task
     */
    private uiStore = useUiStore();

    task(forcedStrategy?: RepositoryStrategyEnum) {
      return adminRepository.getUsers(forcedStrategy).then((localRslt) => {
        this.uiStore.users = localRslt;

        return localRslt;
      });
    }
  };
}
